<template lang="pug">
.aiq-form(v-if="!disabled")
  nps-form(v-if="form.survey_type === 'nps'"
           :content="form.content"
           :config="form.nps"
           @submit="onSubmit"
           @cancel="onCancel")
  csat-form(v-if="form.survey_type === 'csat'"
            :content="form.content"
            :config="form.csat"
            @submit="onSubmit"
            @cancel="onCancel")
</template>

<style lang="scss" scoped>
.aiq-form {
  background: white;
}
</style>
<script>
import NpsForm from './NPS/NPS.vue';
import CsatForm from './CSAT/CSAT.vue';

export default {
  name: 'aiq-custom-form',
  components: {
    NpsForm,
    CsatForm,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default() {
        return {
          survey_type: '',
          nps: null,
          csat: null,
        };
      },
    },
    inWebchat: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onSubmit(formPayload) {
      const { type, ...content } = formPayload;
      const payload = { type, content };
      this.$emit('submit', payload);
    },
    onCancel(payload) {
      this.$emit('cancel', payload);
    },
  },
};
</script>
